// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__3H1mu","BreadTop":"BurgerIngredient__BreadTop__11Tm0","Seeds1":"BurgerIngredient__Seeds1__3-qVY","Seeds2":"BurgerIngredient__Seeds2__2NHaT","Patty":"BurgerIngredient__Patty__28Fsr","Cheese":"BurgerIngredient__Cheese__20iQM","Salad":"BurgerIngredient__Salad__rjwnr","Mayo":"BurgerIngredient__Mayo__3_W69"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Ingredients/BurgerIngredient.css
// module id = 105
// module chunks = 3